import { createSelector } from 'reselect';
import { shouldShowChannelCover } from 'widget/utils/overlay-buttons-utils';
import { getChannelForWidget } from 'shared/selectors/channels';


const getVideo = (state, props) => props.videoItem;
const getUseChannelCoverIfPossible = (state, props) => props.useChannelCoverIfPossible;
const getSettings = state => state.appSettings;

export const getPlayerCoverUrl = createSelector(
  [
    getSettings,
    getChannelForWidget,
    getVideo,
    getUseChannelCoverIfPossible,
  ],
  (settings, channel, video, useChannelCoverIfPossible) => {

    const { customCoverUrl, coverUrl } = video;

    let url = customCoverUrl || coverUrl;

    if (shouldShowChannelCover(settings, useChannelCoverIfPossible)) {
      url = channel.customCoverUrl || channel.coverUrl || url;
    }

    return url;
  }
);



// WEBPACK FOOTER //
// ./src/widget/components/player-cover/player-cover-selector.js